/* =========================================================================
   CASCADE LIGHTING — <cascade-newsletter> (sections/cascade-newsletter.liquid)
   Client-side validation from the prototype. Valid emails submit normally to
   Shopify's customer form; server success / errors are rendered in Liquid.
   ========================================================================= */
if (!customElements.get('cascade-newsletter')) {
  class CascadeNewsletter extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.input = this.querySelector('input[type="email"]');
      this.message = this.querySelector('[data-newsletter-message]');
      if (!this.form || !this.input || !this.message) return;
      this.EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

      this.form.addEventListener('submit', (event) => {
        const value = this.input.value.trim();
        if (!value) {
          event.preventDefault();
          this.invalid(this.dataset.errorEmpty);
          return;
        }
        if (!this.EMAIL.test(value)) {
          event.preventDefault();
          this.invalid(this.dataset.errorInvalid);
          return;
        }
        this.input.value = value;
        this.input.removeAttribute('aria-invalid');
        this.setMessage('', '');
      });

      this.input.addEventListener('input', () => {
        if (this.input.getAttribute('aria-invalid') !== 'true') return;
        this.input.removeAttribute('aria-invalid');
        this.setMessage('', '');
      });
    }

    invalid(text) {
      this.input.setAttribute('aria-invalid', 'true');
      this.setMessage(text, 'error');
      this.input.focus();
    }

    setMessage(text, type) {
      this.message.textContent = text;
      this.message.classList.toggle('is-error', type === 'error');
      this.message.classList.toggle('is-success', type === 'success');
    }
  }

  customElements.define('cascade-newsletter', CascadeNewsletter);
}
